let customProductVariants = document.querySelector('.product-variants');
if (customProductVariants) {
    let showMoreVariants = document.querySelector('.product-variants__show-more');
    let allVariants = document.querySelector('.product-variants__wrapper');

    if (showMoreVariants && allVariants) {
        showMoreVariants.addEventListener('click', function () {
            if (allVariants.style.display === 'none') {
                allVariants.style.display = 'flex';
                showMoreVariants.style.display = 'none';
            }

            while (allVariants.firstChild) {
                allVariants.parentNode.insertBefore(allVariants.firstChild, allVariants);
            }

            allVariants.remove();
        });
    }
}
